import { CalendarOutlined, LayoutOutlined, ScheduleOutlined, TableOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import ModuleSidebarLayout from "../../components/moduleSidebar/ModuleSidebarLayout";
import { SCHEMA_PAGE_PATH } from "./logic/schemaSetup";

/**
 * Модулът „Резервации" със страничното меню (като „Конфигурация"): всяка
 * страница е по право. „Резервации" и „Таблица на резервациите" са под едно
 * право (view_reservations); „Схема на заведението" и „Конфигурация на маси" —
 * всяка със своето. Правата трябва да съвпадат с route-овете в main.tsx.
 */
const ReservationsLayout = () => {
  const { t } = useTranslation();

  // Редът определя и fallback-а „първата разрешена страница".
  const sections = [
    {
      title: null,
      pages: [
        {
          path: "/reservations",
          permission: "view_reservations",
          label: t("reservationsSidebar.reservations"),
          Icon: CalendarOutlined,
        },
        {
          path: "/reservations/table",
          permission: "view_reservations",
          label: t("reservationsSidebar.table"),
          Icon: ScheduleOutlined,
        },
        {
          path: SCHEMA_PAGE_PATH,
          permission: "manage_restaurant_schema",
          label: t("reservationsSidebar.restaurantSchema"),
          Icon: LayoutOutlined,
        },
        {
          path: "/reservations/tables",
          permission: "manage_tables",
          label: t("reservationsSidebar.tablesConfig"),
          Icon: TableOutlined,
        },
      ],
    },
  ];

  return (
    <ModuleSidebarLayout
      rootPath="/reservations"
      moduleLabel={t("reservationsSidebar.moduleLabel")}
      sections={sections}
    />
  );
};

export default ReservationsLayout;
